module.exports = __webpack_public_path__ + "static/media/RestDayCupActive.b5c016fb.svg";